<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100" fxFlex>
    @if (filterFields?.length) {
        <af-filter #filter
                   class="w-100 mt-24"
                   [filterFields]="filterFields"
                   (filterListener)="filterData($event)"
                   placeholderContext="notifications"
                   [filterEvent]="filterEvent"
                   [showImport]="false"
                   [showExport]="false"
                   [showSearchBar]="true"/>
    }
    <div #scrollWrapper
         fxFlex
         fxLayout="column"
         fxLayoutAlign="start start"
         class="w-100 overflow-y-scroll"
         fxLayoutGap="12px"
         [class.mt-24]="!filterFields?.length"
         [class.mt-32]="filterFields?.length">
        @for (notification of notifications; track notification; let index = $index) {
            <af-notification-item
                #notificationItem
                [notification]="notification"
                [highlightNew]="markOnVisible"
                [attr.data-index]="index"
                class="w-100"/>
        }
        @if (infiniteScroll) {
            <div #sentinel class="w-100"></div>
        }
    </div>
    @if (!notifications?.length) {
        <div class="w-100 h-100">
            <ui-kit-empty-state class="mt-24 w-100"
                                [icon]="emptyStateIcon"
                                [spinnerIds]="spinnerIds"
                                [title]="emptyStateTitle"
                                [subtitle]="emptyStateSubtitle"
                                backgroundColor="light"
                                [buttonLabel]="emptyStateButton"
                                (clickListener)="onEmptyStateClick()"
                                [items]="notifications"/>
        </div>
    }
    @if (!infiniteScroll) {
        <af-paginator #paginator
                      fxFlexAlign="end"
                      [spinnerIds]="['initial','filter']"
                      class="mt-16 no-select"
                      (scrollEmitter)="scrollToTop($event)"
                      (pageChangeListener)="pageChanges($event)"
                      [currentPageEvent]="pageEvent"
                      [totalElements]="totalElements"/>
    }
</div>
